









































import {Component, Prop, Vue} from 'vue-property-decorator';
import {ProductContractContent} from '@/types';
import DownloadIcon from '@/assets/icons/icn-download.svg';
import {getKeycloak} from "@/components/auth/keycloak";

@Component({
  components: {
    DownloadIcon,
  },
})
export default class ContractLink extends Vue {
  @Prop() public contract: ProductContractContent;
  public token = getKeycloak().token;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/ContractLink/ContractLink.vue